<template>
  <div class="wrapper">
    <h2>{{ error.statusCode }}</h2>
    <p>{{ error.message }}</p>
    <img class="empty-img" src="./assets/img/empty.png" />
    <div class="error-tip">页面内容不见了</div>
  </div>
</template>
<script setup>
if (process.client) {
  import('@/public/js/flexible')
}
const props = defineProps({
  error: {
    type: Object,
    required: true,
  },
})
</script>
<style lang="less" scoped>
.wrapper {
  margin: 0;
  margin-left: -0.1rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 75vh;
  font-size: 1vw;
  overflow: hidden;
  position: relative;
  .empty-img {
    width: 50vw;
    height: auto;
  }
  .error-tip {
    color: #666;
    line-height: 1.5;
    margin-top: 0.3rem;
    font-size: 0.2rem;
  }
  .reload-btn {
    letter-spacing: 0.5px;
    color: #ff5848;
    font-size: 0.28rem;
    background-color: #ffeae5;
    padding: 0.2rem 0.78rem;
    border-radius: 0.12rem;
    margin-top: 0.48rem;
    margin-left: -0.1rem;
  }
  .go-back {
    position: absolute;
    left: 0.18rem;
    top: 0.51rem;
    width: 0.58rem;
    height: 0.58rem;
    display: none;
  }
}
</style>
